import { Controller } from "stimulus"

// Filters a long list of podcast check boxes by title and checks every visible one at once.
// Rows are hidden with the `hidden` class and never disabled, so a filtered-out podcast keeps its
// state and still submits with the form. Locked rows (disabled, checked) are never changed.
export default class PodcastPickerController extends Controller {
  static targets = ["filter", "count", "empty"]

  connect() {
    this.updateCount()
  }

  // Enter in the filter box narrows the list; it must not submit the product form.
  ignoreEnter(event) {
    event.preventDefault()
  }

  filter() {
    const words = this.filterTarget.value.toLowerCase().split(/\s+/).filter(Boolean)
    let shown = 0
    this.rows.forEach((row) => {
      const text = row.textContent.toLowerCase()
      const match = words.every((word) => text.includes(word))
      row.classList.toggle("hidden", !match)
      if (match) shown++
    })
    this.emptyTarget.classList.toggle("hidden", shown > 0)
  }

  selectAllShown(event) {
    event.preventDefault()
    this.rows.forEach((row) => {
      const box = this.checkbox(row)
      if (!row.classList.contains("hidden") && !box.disabled) box.checked = true
    })
    this.updateCount()
  }

  updateCount() {
    const selected = this.rows.filter((row) => this.checkbox(row).checked).length
    this.countTarget.textContent = `${selected} of ${this.rows.length} selected`
  }

  get rows() {
    return Array.from(this.element.querySelectorAll(".podcast-row"))
  }

  checkbox(row) {
    return row.querySelector("input[type=checkbox]")
  }
}
